import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Blog = () => {
  const { t } = useTranslation();

  return (
    <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '40px 20px', background: '#080810', color: '#F5F5F0', fontFamily: 'Inter, sans-serif' }}>
      <Link to="/" style={{ color: '#F0B429', textDecoration: 'none', display: 'inline-block', marginBottom: '24px' }}>
        ← {t('back_to_home')}
      </Link>

      <h1 style={{ fontFamily: 'Oswald, sans-serif', fontSize: '32px', letterSpacing: '2px', textAlign: 'center', marginBottom: '8px' }}>
        BLOG <span style={{ color: '#F0B429' }}>PITAZO MUNDIAL</span>
      </h1>
      <div style={{ textAlign: 'center', color: '#888', marginBottom: '48px', fontSize: '14px' }}>
        {t('blog_description')}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '24px', marginBottom: '48px' }}>
        {/* Artículo 1 */}
        <div style={{ background: '#14141f', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '16px', overflow: 'hidden', transition: 'transform 0.2s' }}>
          <div style={{ padding: '20px' }}>
            <div style={{ fontSize: '11px', color: '#F0B429', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>
              📅 {t('blog_date1')}
            </div>
            <h2 style={{ fontFamily: 'Oswald, sans-serif', fontSize: '18px', marginBottom: '12px', color: '#F5F5F0' }}>
              {t('blog_title1')}
            </h2>
            <p style={{ fontSize: '13px', color: '#aaa', marginBottom: '16px' }}>
              {t('article1_content')}
            </p>
            <a href="/blog/calendario-mundial-2026" style={{ color: '#F0B429', textDecoration: 'none', fontSize: '12px', fontWeight: '600' }}>
              Leer más →
            </a>
          </div>
        </div>

        {/* Artículo 2 */}
        <div style={{ background: '#14141f', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '16px', overflow: 'hidden' }}>
          <div style={{ padding: '20px' }}>
            <div style={{ fontSize: '11px', color: '#F0B429', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>
              ⚽ {t('blog_date2')}
            </div>
            <h2 style={{ fontFamily: 'Oswald, sans-serif', fontSize: '18px', marginBottom: '12px', color: '#F5F5F0' }}>
              {t('blog_title2')}
            </h2>
            <p style={{ fontSize: '13px', color: '#aaa', marginBottom: '16px' }}>
              {t('article2_content')}
            </p>
            <a href="/blog/selecciones-favoritas-mundial-2026" style={{ color: '#F0B429', textDecoration: 'none', fontSize: '12px', fontWeight: '600' }}>
              Leer más →
            </a>
          </div>
        </div>

        {/* Artículo 3 */}
        <div style={{ background: '#14141f', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '16px', overflow: 'hidden' }}>
          <div style={{ padding: '20px' }}>
            <div style={{ fontSize: '11px', color: '#F0B429', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>
              🎯 {t('blog_date3')}
            </div>
            <h2 style={{ fontFamily: 'Oswald, sans-serif', fontSize: '18px', marginBottom: '12px', color: '#F5F5F0' }}>
              {t('blog_title3')}
            </h2>
            <p style={{ fontSize: '13px', color: '#aaa', marginBottom: '16px' }}>
              {t('article3_content')}
            </p>
            <a href="/blog/como-funciona-pitazo-mundial" style={{ color: '#F0B429', textDecoration: 'none', fontSize: '12px', fontWeight: '600' }}>
              Leer más →
            </a>
          </div>
        </div>

        {/* Artículo 4 */}
        <div style={{ background: '#14141f', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '16px', overflow: 'hidden' }}>
          <div style={{ padding: '20px' }}>
            <div style={{ fontSize: '11px', color: '#F0B429', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>
              💡 {t('blog_date4')}
            </div>
            <h2 style={{ fontFamily: 'Oswald, sans-serif', fontSize: '18px', marginBottom: '12px', color: '#F5F5F0' }}>
              {t('blog_title4')}
            </h2>
            <p style={{ fontSize: '13px', color: '#aaa', marginBottom: '16px' }}>
              {t('article4_content')}
            </p>
            <a href="/blog/consejos-ganar-predicciones" style={{ color: '#F0B429', textDecoration: 'none', fontSize: '12px', fontWeight: '600' }}>
              Leer más →
            </a>
          </div>
        </div>
      </div>

      <div style={{ textAlign: 'center', marginTop: '40px', paddingTop: '32px', borderTop: '1px solid rgba(255,255,255,0.07)' }}>
        <Link to="/privacy" style={{ color: '#888', textDecoration: 'none', margin: '0 12px', fontSize: '12px' }}>{t('privacy')}</Link>
        <Link to="/contact" style={{ color: '#888', textDecoration: 'none', margin: '0 12px', fontSize: '12px' }}>{t('contact_link')}</Link>
        <Link to="/terms" style={{ color: '#888', textDecoration: 'none', margin: '0 12px', fontSize: '12px' }}>{t('terms_link')}</Link>
        <Link to="/" style={{ color: '#888', textDecoration: 'none', margin: '0 12px', fontSize: '12px' }}>{t('back_to_home')}</Link>
      </div>
    </div>
  );
};

export default Blog;